import React from 'react';
import { TableRow } from '@mui/material';
import { FormAutocomplete } from '~/components/FormComponents/FormAutocomplete.tsx';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import type { ILoanOrBondRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/loansAndBonds/types.ts';
import {
  filterBankOptions,
  normalizeBalanceLine,
  normalizeDecimalValue,
  validateBalanceLine,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';
import { financialConditionTableFieldStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

export const LoanOrBondRow: React.FC<ILoanOrBondRowProps> = ({
  name,
  index,
  canRemove,
  disabled,
  lenderOptions,
  currencyOptions,
  isBanksLoading,
  isCurrenciesLoading,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`${name}.${index}.lenderName`}
        label="Найменування кредитора"
        options={lenderOptions}
        loading={isBanksLoading}
        filterOptions={filterBankOptions}
        shouldSaveLabel
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.lenderCode`}
        label="Код ЄДРПОУ кредитора"
        type="text"
        inputProps={{ inputMode: 'numeric' }}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`${name}.${index}.receivedDate`}
        label="Дата отримання"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`${name}.${index}.maturityDate`}
        label="Дата погашення"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`${name}.${index}.currency`}
        label="Валюта"
        options={currencyOptions}
        loading={isCurrenciesLoading}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.currentAmount`}
        label="Поточна сума, тис. од."
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.balanceLine`}
        label="Рядок балансу"
        placeholder="р.1550"
        normalizeOnBlur={normalizeBalanceLine}
        rules={{ validate: validateBalanceLine }}
        inputProps={{ inputMode: 'numeric', maxLength: 6 }}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.balanceLineField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.overdueDebt`}
        label="Прострочення, тис. од."
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити запис ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
